module.exports = __webpack_public_path__ + "static/img/2017-B.4b57c32.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/dynamic/events/2017-B.png
// module id = 59ZA
// module chunks = 1